import { observer } from 'mobx-react-lite';
import Popup from '../../../../components/common-components/pop-up/Popup';
import { useStore } from '../../../../hooks/useStore';
import styles from './AppointmentDetailPopup.module.css';
import moment from 'moment';
import 'moment/locale/tr';
import { Navigation2 } from 'lucide-react';

moment.locale('tr');

const AppointmentDetailPopup = () => {
  const { popupStore, appointmentStore } = useStore();
  const appointment = appointmentStore.selectedAppointmentToView;

  const handleClose = () => {
    popupStore.setIsAppointmentDetailOpen(false);
    appointmentStore.setSelectedAppointmentToView(null);
  };

  if (!appointment) {
    return null;
  }

  const formatDate = (dateStr?: string) => {
    if (!dateStr) return '-';
    return moment(dateStr).format('DD.MM.YYYY');
  };

  const formatDateTime = (dateStr?: string, startTime?: string, endTime?: string) => {
    if (!dateStr || !startTime) return '-';
    const start = moment(`${dateStr} ${startTime}`, 'YYYY-MM-DD HH:mm').format('DD.MM.YYYY HH:mm');
    if (endTime) {
      const end = moment(`${dateStr} ${endTime}`, 'YYYY-MM-DD HH:mm').format('HH:mm');
      return `${start} - ${end}`;
    }
    return start;
  };

  const handleOpenGoogleMaps = () => {
    if (appointment?.hospitalLocation) {
      const encodedLocation = encodeURIComponent(appointment.hospitalLocation);
      const googleMapsUrl = `https://www.google.com/maps/dir/?api=1&destination=${encodedLocation}`;
      window.open(googleMapsUrl, '_blank');
    }
  };

  const hasLocation = appointment?.hospitalLocation && appointment.hospitalLocation.trim() !== '';

  return (
    <Popup
      isOpen={popupStore.isAppointmentDetailOpen}
      onClose={handleClose}
      title="Randevu Detayları"
    >
      <div className={styles.container}>
        <div className={styles.detailSection}>
          <div className={styles.detailRow}>
            <span className={styles.label}>Kişi Adı:</span>
            <span className={styles.value}>{appointment.personName || '-'}</span>
          </div>

          <div className={styles.detailRow}>
            <span className={styles.label}>Etiket Numarası:</span>
            <span className={styles.value}>{appointment.requestNumber || '-'}</span>
          </div>

          <div className={styles.detailRow}>
            <span className={styles.label}>Hastane:</span>
            <span className={styles.value}>{appointment.hospitalName || '-'}</span>
          </div>

          <div className={styles.detailRow}>
            <div className={styles.locationRow}>
              <div className={styles.locationContent}>
                <span className={styles.label}>Hastane Konumu:</span>
                <span className={styles.value}>{appointment.hospitalLocation || '-'}</span>
              </div>
              {hasLocation && (
                <button
                  onClick={handleOpenGoogleMaps}
                  className={styles.mapButton}
                  title="Konuma Git"
                >
                  <Navigation2 size={18} />
                  <span>Konuma Git</span>
                </button>
              )}
            </div>
          </div>

          <div className={styles.detailRow}>
            <span className={styles.label}>Randevu Tarihi:</span>
            <span className={styles.value}>{formatDate(appointment.appointmentDate)}</span>
          </div>

          <div className={styles.detailRow}>
            <span className={styles.label}>Randevu Saati Aralığı:</span>
            <span className={styles.value}>
              {appointment.appointmentStartTime && appointment.appointmentEndTime
                ? `${appointment.appointmentStartTime} - ${appointment.appointmentEndTime}`
                : '-'}
            </span>
          </div>

          <div className={styles.detailRow}>
            <span className={styles.label}>Randevu Tarihi ve Saati:</span>
            <span className={styles.value}>
              {formatDateTime(
                appointment.appointmentDate,
                appointment.appointmentStartTime,
                appointment.appointmentEndTime
              )}
            </span>
          </div>

          <div className={styles.detailRow}>
            <span className={styles.label}>Kullanıcı:</span>
            <span className={styles.value}>{appointment.userName || appointment.userId || '-'}</span>
          </div>

          <div className={styles.detailRow}>
            <span className={styles.label}>Cihaz Listesi:</span>
            <span className={styles.value}>{appointment.deviceList || '-'}</span>
          </div>
        </div>
      </div>
    </Popup>
  );
};

export default observer(AppointmentDetailPopup);
